module.exports = __webpack_public_path__ + "assets/img/bc86599a2fe25940f9df1ab88897d897.svg";